import { GeoPoint } from '@common/model/location/geopoint';
import { useEffect, useState } from 'react';
import { getDeviceLocation } from './getLocation';

export const useDeviceLocation = (): GeoPoint | null => {
  const [geoPoint, setGeoPoint] = useState<GeoPoint | null>(null);
  useEffect(() => {
    getDeviceLocation().then(setGeoPoint).catch(console.warn);
  }, []);
  return geoPoint;
};
